import React, { useState, useMemo, useEffect } from "react";
import { Card, Container, CardBody, CardHeader, Row } from "reactstrap";
import BreadCrumb from "../../components/common/breadCrumb";
import { getRole } from "../../utils/helpers/custom";
import TableContainer from "../../components/common/tableContainer";
import Loader from "../../components/common/loader";
import { Link, useLocation } from "react-router-dom";
import NoResultsMessage from "../../components/noResultMessage";
import ApproveRejectModal from "../../components/common/approveRejectModal";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { deleteProjectDetails, listOfAssignProjectModule, listOfProject } from "../../api/itpProject";
import { toast } from "react-toastify";
import { ItpLabel } from "../../common/constant/Itp";
import { checkStatusCodeSuccess, CommonLabel, Roles } from "../../utils/helpers/common";
import BaseButton from "../../components/BaseComponents/BaseButton";

const ITPProjectModule = (props) => {
  document.title = ItpLabel.ItpProjectModule;
  const location = useLocation();
  const id = location.state?.id;
  const [loading, setLoading] = useState(false);
  const [tableLoader, setTableLoader] = useState(false);
  const [selectedRow, setSelectedRow] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [selectedDeleteId, setSelectedDeleteId] = useState();
  const [projectName, setProjectName] = useState(null);
  const role = getRole();

  const listOfProjectFun = () => {
    setTableLoader(true);
    listOfProject({
        itpProjectId: id
    })
      .then((res) => {
        if (checkStatusCodeSuccess(res?.statusCode)) {
          setSelectedRow(res?.data[0]?.itpProjectDetails);
          console.log('res', res?.data[0]?.projectName);
          setProjectName(res?.data[0]?.projectName);
        } else {
          toast.error(res?.data?.message);
        }
      })
      .catch((err) => err)
      .finally(() => {
        setTableLoader(false);
      });
  };

  const listOfProjectModules = () => {
    setTableLoader(true);
    listOfAssignProjectModule(id)
      .then((res) => {
        if (checkStatusCodeSuccess(res?.statusCode)) {
          setSelectedRow(res?.data[0]?.itpProjectDetails);
          projectName = res?.data[0]?.projectName;
        } else {
          toast.error(res?.data?.message);
        }
      })
      .catch((err) => err)
      .finally(() => {
        setTableLoader(false);
      });
  };

  useEffect(() => {
    listOfProjectFun();
    if (role  === Roles.Employee) {
      listOfProjectModules();
    }
  }, []);

  const QueryColumns = useMemo(() => [
    {
      Header: ItpLabel.Module,
      accessor: "module",
      filterable: false,
    },
    {
      Header: ItpLabel.Day,
      accessor: "days",
      filterable: false,
    },
    {
      Header: ItpLabel.Api,
      accessor: "apis",
      filterable: false,
    },
    {
      Header: ItpLabel.Screen,
      accessor: "screen",
      filterable: false,
    },
    {
      Header: ItpLabel.ApiEndPoints,
      Cell: (cellProps) => {
        const Celldata = cellProps.row.original.apiEndPoints;
        return (
          <div>
            <div className="hstack gap-2">{HtmlToJsx(Celldata)}</div>
          </div>
        );
      },
      accessor: "apiEndPoints",
      filterable: false,
    },
    ...(role !== Roles.Employee
    ? [
    {
      Header: CommonLabel.Action,
      Cell: (cellProps) => {
        return (
          <div>
            <div className="hstack gap-2">
              {role !== Roles.Employee && (
                <>
                <Link
                  id={`deleteTodo-${cellProps?.cell?.row?.original?.id}`}
                  className="btn btn-sm btn-soft-danger remove-list"
                  onClick={() => {
                    console.log('check value');
                    handleDelete(cellProps?.cell?.row?.original?.id)
                  }
                  }
                >
                  <i className="ri-delete-bin-5-fill align-bottom" />
                </Link>
                  <ReactTooltip
                    place="bottom"
                    variant="error"
                    content="Delete"
                    anchorId={`deleteTodo-${cellProps?.cell?.row?.index}`}
                  />
                </>
              )}
              {role === Roles.Employee && (
                <>
                <Link
                  className="btn btn-sm btn-soft-danger remove-list"
                  disabled
                >
                  <i className="ri-delete-bin-5-fill align-bottom" />
                </Link>
                  <ReactTooltip
                    place="bottom"
                    variant="error"
                    content="Delete"
                    anchorId={`deleteTodo-${cellProps?.cell?.row?.index}`}
                  />
                </>
              )}
            </div>
          </div>
        );
      },
    },
  ] : [])
  ]);

  // Delete
  const handleDelete = (id) => {
    setSelectedDeleteId(id);
    setDeleteModal(true);
  };

  const handleDeleteTodo = () => {
    setLoading(true);
    deleteProjectDetails({id: selectedDeleteId})
      .then((res) => {
        if (checkStatusCodeSuccess(res?.data?.statusCode)) {
          toast.success(res?.data?.message);
          listOfProjectFun();
        } else {
          toast.error(res?.data?.message);
        }
      })
      .catch((err) => err)
      .finally(() => {
        setDeleteModal(false);
        setLoading(false);
        listOfProjectFun();
      });
  };

  function HtmlToJsx(htmlString) {
    return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
  }

  return (
    <React.Fragment>
      <ApproveRejectModal
        show={deleteModal}
        onDeleteClick={() => handleDeleteTodo()}
        onCloseClick={() => setDeleteModal(false)}
        action={selectedRow ? selectedRow.action : ""}
        loader={loading}
      />
      <div className="page-content">
          <Container fluid>
            <BreadCrumb title="ITP Project Module" pageTitle="ITP Project" navigation="/itp-project" />
            <Row className="mb-2">
              <div className="col-sm order-3 order-sm-2 mt-3 mt-sm-0">
                <h5 className="fw-semibold mt-2">
                  {ItpLabel.ItpProjectModule}
                </h5>
              </div>

              <div className="col-auto order-2 order-sm-3 ms-auto">
                <div className="hstack gap-2">
                    <Link to="/itp-project">
                      <BaseButton
                        color="primary"
                        type="button">
                        {CommonLabel.Back}
                      </BaseButton>
                    </Link>
                </div>
              </div>
            </Row>
            <Card>
              <CardHeader className="align-items-center d-flex">
                <h4 className="card-title mb-0 flex-grow-1">{projectName}</h4>
              </CardHeader>

              <CardBody>
                  <>
                    {(selectedRow?.length ||tableLoader) ? (
                      <TableContainer
                        columns={QueryColumns}
                        data={selectedRow || []}
                        isAddUserList={false}
                        customPageSize={10}
                        isGlobalFilter={true}
                        tableLoader={tableLoader}
                        divClass="table-responsive table-card mb-1 "
                        tableClass="align-middle table-nowrap "
                        theadClass="table-light text-muted"
                        SearchPlaceholder={CommonLabel.Search}
                      />
                    ) : (
                      <NoResultsMessage />
                    )}
                  </> 
                </CardBody>
            </Card>
          </Container>
      </div>
    </React.Fragment>
  );
};

export default ITPProjectModule;
